<div class="opacity-slider">
  <input
    #opacitySlider
    type="range"
    min="0"
    max="100"
    step="1"
    [value]="layerOpacity"
    (input)="layerOpacity = opacitySlider.value"
  />
  <div class="opacity-value">{{ layerOpacity }}%</div>
</div>
